const henceforward = {
    disabledDate (time) {
        return time.getTime() < (new Date().getTime()) - 1 * 24 * 3600 * 1000
    }
}
export default henceforward